export default class slideUp {
    constructor() {
        return {
            restrict: 'A',
            controller: [
                '$scope', '$element', '$attrs', '$animate',
                (scope, element, attrs, $animate) => {
                    scope.$watch(attrs.slideUp, function(newVal) {
                        if (newVal) {
                            $animate.addClass(element, 'slide-up')
                        } else {
                            $animate.removeClass(element, 'slide-up')
                        }
                    })
                }]
        }
    }
}